import { pushToGTM } from "@lib/gtmUtility"
const category = "Labs Search Bar"

export function trackSearchQuery(label) {
    const gaConfig = {
        label,
        category,
        action: "Search Term",
    }

    pushToGTM(gaConfig)
}

export function trackClearRecentSearches(label) {
    const gaConfig = {
        label,
        category,
        action: "Clear All",
    }

    pushToGTM(gaConfig)
}

export function trackRemoveTest(label = "") {
    const gaConfig = {
        label,
        category,
        action: "Remove Test",
    }

    pushToGTM(gaConfig)
}
export function trackNoTestFound(label = "") {
    const gaConfig = {
        label,
        category,
        action: "No Tests found",
    }

    pushToGTM(gaConfig)
}

export function trackAboutTest(label, action) {
    const gaConfig = {
        label,
        category,
        action: action || "About test",
    }

    pushToGTM(gaConfig)
}
